import { addDoubleQuotes } from '../utils/smartutils';

export function subjectListByFilterQuery(filter) {
  const query = `{subjectListByFilter(filter: ${JSON.stringify(filter).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}) {id, name, description, active}}`;
  return query;
}

export function subjectListAllQuery() {
  const query = '{subjectListAll{id, name, active}}';
  return query;
}

export function subjectListAllIdName() {
  const query = '{subjectListAll{id, name}}';
  return query;
}

export function subjectListByEmployeeQuery(employeeId) {
  const query = `{subjectListByEmployee(employeeId : ${employeeId}){id, name, active}}`;
  return query;
}

export function subjectRemoveMutation(id) {
  const mutation = `mutation {subjectRemove(id: ${id})}`;
  return mutation;
}

export function subjectSaveMutation(values) {
  const mutation = `mutation {
    subjectSave(
        subject: {id: ${values.id ? values.id : 0}
                , name: "${values.name}"
                , description: ${addDoubleQuotes(values.description)}
                , active: ${values.active}
                , filterByStatus: false
                , subjectLevelFilterId: 0
                , updaterId: 0
                , termFilterId: 0}),
    {id}
    }`;
  return mutation;
}

export function subjectLabelValueListByFilter(filter) {
  return `{subjectListByFilter(filter: ${JSON.stringify(filter).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}) {id, value, label, name}}`;
}

export function subjectListByFilter(filter) {
  return `{subjectListByFilter(filter: ${JSON.stringify(filter).replace(
    /"([^(")"]+)":/g,
    '$1:'
  )}) {id, name, description, active}}`;
}
